export interface RendererConfig {
  backgroundColor: number;
  antialias: boolean;
  resolution: number;
  autoDensity: boolean;
}

export interface WorldConfig {
  width: number;
  height: number;
}

export interface GameConfig {
  renderer: RendererConfig;
  world: WorldConfig;
}

export const gameConfig: GameConfig = {
  renderer: {
    backgroundColor: 0x1a1a1a,
    antialias: false, // Disable antialiasing for crisp pixel art
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
  },
  world: {
    width: 2000,
    height: 1500,
  },
};
